<template>
    <div>
        <div style="margin-top: 0" class="common-table">
            <el-table v-loading="loading" :data="clubCreate.beanList" row-key="msgId" height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" align="center" prop="userId"/>
                <el-table-column label="用户昵称" align="center" prop="nickname"/>
                <el-table-column label="俱乐部名称" align="center" prop="clubName"/>
                <el-table-column label="俱乐部简介" align="center" prop="clubDesc"/>
                <el-table-column label="联系方式" align="center" prop="contact"/>
                <el-table-column label="留言框" align="center" prop="message"/>
                <el-table-column label="申请时间" align="center" prop="createTime"/>
                <el-table-column align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="reject(scope.row.msgId)">拒绝</el-button>
                        <el-button type="success" size="mini" @click="setConfigFunc(scope.row)">同意</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination class="common-el-pagination"
                       layout="prev,pager,next,jumper"
                       background
                       :page-size="20"
                       :pager-count="5"
                       :current-page="currentPage"
                       @current-change="getList($event)"
                       :total="clubCreate.total"/>

        <div v-show="configIsShow" class="common-popup-bg">
            <div class="common-popup">
                <h3>设置条件</h3>
                <table class="common-popup-table">
                    <tr>
                        <td>申请人：</td>
                        <td v-text="`${configForm.nickname}(${configForm.userId})`"></td>
                    </tr>
                    <tr>
                        <td>占成率：</td>
                        <td>
                            <el-radio-group v-model="configForm.profit">
                                <el-radio label="">默认(70%)</el-radio>
                                <el-radio :label="profitVal">自定义
                                    <el-input
                                            size="medium"
                                            type="number"
                                            max="70"
                                            suffix-icon="icon-percent"
                                            v-model="profitVal"/>
                                </el-radio>
                            </el-radio-group>
                        </td>
                    </tr>
                    <tr>
                        <td>联&nbsp;&nbsp;&nbsp;&nbsp;盟：</td>
                        <td>
                            <el-select
                                    v-model="configForm.tribeId"
                                    size="medium"
                                    filterable
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in allUnionList"
                                        :key="item.id"
                                        :label="item.tribeName"
                                        :value="item.id"/>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td>人&nbsp;&nbsp;&nbsp;&nbsp;数：</td>
                        <td>
                            <el-radio-group v-model="configForm.memberUpperLimit">
                                <el-radio label="">默认(1000)</el-radio>
                                <el-radio :label="memberUpperLimitVal">自定义
                                    <el-input
                                            size="medium"
                                            type="number"
                                            min="1"
                                            max="2000"
                                            v-model="memberUpperLimitVal"/>
                                </el-radio>
                            </el-radio-group>
                        </td>
                    </tr>
                    <tr>
                        <td>代充渠道：</td>
                        <td>
                            <el-select
                                    v-model="configForm.payChannelId"
                                    size="medium"
                                    filterable
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in channelList.beanList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"/>
                            </el-select>
                        </td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" @click="configIsShow = false">取消</el-button>
                    <el-button size="small" type="primary" @click="approve">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                configIsShow: false,
                profitVal: 1,
                memberUpperLimitVal: 1,
                configForm: {},
                currentPage: 1
            }
        },
        computed: {
            ...mapState('managementMsg', ['clubCreate']),
            ...mapState('union', ['allUnionList']),
            ...mapState('payChannel', ['channelList']),
        },
        watch: {
            profitVal(newVal) {
                if (newVal === 1) return;
                this.configForm.profit = newVal;
            },
            memberUpperLimitVal(newVal) {
                if (newVal === 1) return;
                this.configForm.memberUpperLimit = newVal;
            }
        },
        created() {
            this.getAllUnionList();
            this.getChannelList();
            this.getList();
        },
        methods: {
            ...mapActions('managementMsg', ['getClubCreateList', 'approveClubCreate', 'rejectClubCreate']),
            ...mapActions('union', ['getAllUnionList']),
            ...mapActions('payChannel', ['getChannelList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getClubCreateList(page).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.clubCreate.beanList.length) {
                        this.getList(this.currentPage - 1)
                    }
                });
            },
            setConfigFunc(row) {
                this.profitVal = 1;
                this.memberUpperLimitVal = 1;
                this.configIsShow = true;
                this.configForm = {
                    userId: row.userId,
                    nickname: row.nickname,
                    msgId: row.msgId,
                    profit: '',
                    tribeId: '',
                    memberUpperLimit: '',
                    payChannelId: ''
                }
            },
            approve() {
                 if (!this.configForm.payChannelId) {
                     this.$message.error('请选择代充渠道');
                     return
                 }
                this.approveClubCreate({
                    memberUpperLimit: this.configForm.memberUpperLimit,
                    msgId: this.configForm.msgId,
                    profit: this.configForm.profit,
                    tribeId: this.configForm.tribeId,
                    payChannelId: this.configForm.payChannelId
                }).then(() => {
                    this.configIsShow = false;
                    this.$message.success('申请已批准');
                    this.getList(this.currentPage)
                })
            },
            reject(msgId) {
                this.loading = true;
                this.rejectClubCreate(msgId).then(() => {
                    this.$message.success('申请已拒绝');
                    this.getList(this.currentPage)
                })
            }
        }
    }
</script>
